import { forwardRef, useState } from 'react'

import { Link } from 'react-router-dom'

import { hasScopesPermission } from '@tribeplatform/gql-client'
import { Space } from '@tribeplatform/gql-client/types'
import { useCollections } from '@tribeplatform/react-sdk/hooks'
import { Input } from '@tribeplatform/react-ui-kit/Input'
import { List } from '@tribeplatform/react-ui-kit/Layout'

import { CollectionsLoading } from '../CollectionMenu/CollectionLoading'
import { SpaceImage } from '../Space/SpaceImage'

export const PostSpacePicker = forwardRef<
  HTMLInputElement,
  { onSelect: (space: Space) => void }
>(({ onSelect }, ref) => {
  const { data: collections, isLoading } = useCollections({
    fields: {
      space: {
        image: 'basic',
        banner: 'basic',
        authMemberProps: 'all',
      },
    },
    variables: {},
    useQueryOptions: {
      retry: 10,
      retryDelay: 1000,
    },
  })
  const [query, setQuery] = useState('')
  let canPost = false
  let foundSpace = false

  return (
    <div className="flex flex-col">
      <Input
        placeholder="Search..."
        onChange={e => setQuery(e.target.value)}
        ref={ref}
      />
      <div
        className="overflow-auto mt-2"
        style={{ maxHeight: 'calc(100vh - 190px)' }}
      >
        <List spacing="sm">
          {collections?.map(collection => {
            const spaces = collection?.spaces?.nodes
              .map(space => {
                if (space) {
                  const [canCreatePost] = hasScopesPermission(space, [
                    'createPost',
                  ])
                  if (canCreatePost) canPost = true
                  if (
                    typeof query === 'string' &&
                    !space.name.match(
                      new RegExp(
                        query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'),
                        'i',
                      ),
                    )
                  )
                    return null
                  if (canCreatePost) {
                    foundSpace = true
                    return space
                  }
                }
                return null
              })
              .filter(space => space !== null)

            if (!spaces?.length) return null

            return (
              <List.Item key={collection?.id}>
                <span className="font-medium">{collection.name}</span>
                <List spacing="none">
                  {spaces.map(space => (
                    <List.Item key={space?.id} className="pb-1">
                      <Link
                        to="#"
                        onClick={() => onSelect(space)}
                        className="mt-1 px-4 p-2 hover:bg-surface-100 rounded-md flex items-center space-x-3 overflow-hidden"
                      >
                        <span className="flex items-center justify-center h-6 w-6">
                          <SpaceImage space={space} size="sm" />
                        </span>
                        <span>{space?.name}</span>
                      </Link>
                    </List.Item>
                  ))}
                </List>
              </List.Item>
            )
          })}
        </List>
        {isLoading && (
          <div className="mb-3">
            <CollectionsLoading />
          </div>
        )}
        {!isLoading && query && !foundSpace ? (
          <div className="py-10 text-center flex flex-col space-y-3">
            <p>Cannot find any space.</p>
          </div>
        ) : null}
        {!isLoading && !canPost ? (
          <div className="py-10 text-center flex flex-col space-y-3">
            <p>
              Unfortunately, you don&apos;t have permission to post at this
              time.
            </p>
            <p>Please try to join a space or try later.</p>
          </div>
        ) : null}
      </div>
    </div>
  )
})
